import React from 'react';
import { beer } from '../../models/beer';
import { Divider } from '@mui/material';

export interface BeerElementProps {
    beer: beer
}

function BeerElement(props: BeerElementProps) {
    return (
        <div className='mt-2'>

            <div className='flex-between-center '>

                <div className='dish-title'>
                    {props.beer.nome}
                </div>
                <div className='dish-description'>
                    {props.beer.vol}%
                </div>
            </div>
            <div className='flex-start-center'>

                <div className='dish-description text-justify'>
                    {props.beer.descrizione}
                </div>
            </div>

            <div className='flex-center-end mt-2'>
                {
                    props.beer.price33 > 0 ?
                        <div className='flex-start-end'>
                            <div className='dish-price'>
                                33cl.
                            </div>
                            <div className='dish-price mr-3 ml-05'>{props.beer.price33}€</div>
                        </div> : <></>
                }
                {
                    props.beer.price75 > 0 ?

                        <div className='flex-start-end'>
                            <div className='dish-price'>
                                75cl.
                            </div>
                            <div className='dish-price ml-05'>{props.beer.price75}€</div>
                        </div> : <></>
                }
                {
                    props.beer.priceQ1 > 0 ?

                        <div className='flex-start-end'>
                            <div className='dish-price'>
                                {props.beer.q1}
                            </div>
                            <div className='dish-price ml-05'>{props.beer.priceQ1}€</div>
                        </div> : <></>
                }
                {
                    props.beer.priceQ2 > 0 ?

                        <div className='flex-start-end'>
                            <div className='dish-price'>
                                {props.beer.q2}
                            </div>
                            <div className='dish-price ml-05'>{props.beer.priceQ2}€</div>
                        </div> : <></>
                }
            </div>
            <Divider className='inset-divider mt-1 mb-3' />

        </div>
    );
}

export default BeerElement;